<template>
	<div id="index">
		<div :class="scrollFlag?'topLan1':'topLan'">
			<img @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link :class="scrollFlag?'box1':'box'" :to="{path: 'index'}">首页
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'platform'}">电商平台</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'about'}">关于我们</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link :class="scrollFlag?'box1':'box'" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a :class="scrollFlag?'box1':'box'">首页
					<div :class="scrollFlag?'boxLine1':'boxLine'"></div>
				</a>
				<a href="platform" :class="scrollFlag?'box1':'box'">电商平台</a>
				<a href="canvass" :class="scrollFlag?'box1':'box'">招商入驻</a>
				<a href="about" :class="scrollFlag?'box1':'box'">关于我们</a>
				<a href="newsCenter" :class="scrollFlag?'box1':'box'">新闻中心</a>
				<a href="recruit" :class="scrollFlag?'box1':'box'">人才招聘</a>
				<a href="downLoad" :class="scrollFlag?'box1':'box'">下载APP</a> -->
			</div>
		</div>
		<div @load="img_load" id="id1" style="width: 100%;height: img_height + 'px'">
			<!-- <el-carousel class="banner" trigger="click" :height="windowHeight+'px'" :autoplay="true" :interval="3000"> -->
			<el-carousel @load="img_load" trigger="click" :autoplay="true" :height="img_height + 'px'" :interval="3000">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index">
					<img @click="jumpLink(item)" style="width: 100%;" mode="widthFix" :src="item.picUrl"
						@load="img_load" ref='img_ref' />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- <div id="id2" style="width: 100%;height: 100%;background-color: #F8F8F8;"> -->
		<div id="id2" style="width: 100%;background-color: #F8F8F8;">
			<div class="text1" @click="testAnime()">走进蝴蝶供应链</div>
			<div class="index-section2-picLan">
				<div class="index-section2-picBox">
					<img class="section2-bigImg" src="../../static/indexPic/img_web1_1@2x.png" />
					<img id="smallPic1" class="section2-smallPic1"
						src="../../static/indexPic/img_zhice_20201207@2x.png" />
					<img id="smallPic2" class="section2-smallPic2"
						src="../../static/indexPic/img_xinghe_20201207@2x.png" />
					<img id="smallPic3" class="section2-smallPic3"
						src="../../static/indexPic/img_jisu_20201207@2x.png" />
					<img id="smallPic4" class="section2-smallPic4"
						src="../../static/indexPic/img_zhibang_20201207@2x.png" />
				</div>
			</div>
			<div class="index-section2-textLan">
				<div class="index-section2-text">
					蝴蝶供应链有限公司有着十二年的工程机械行业经验和资源沉淀，同时拥有专业的软件开发团队和互联网运营经验，是一家以技术为驱动、数字化解决方案为核心的公司。公司以推动工程机械行业转型为目标，为行业赋能，实现行业的信息化、数字化、智能化，达到降本增效的目的。
				</div>
			</div>
		</div>
		<div id="id3" style="width: 100%;">
			<div class="text1">蝴蝶供应链“创世蜜蜂APP”电商平台</div>
			<div class="index-section3-picLan">
				<div class="index-section3-picBox">
					<img class="section3-bigImg" src="../../static/indexPic/img_web03_appmodel.png" />
				</div>
			</div>
			<div class="index-section3-textLan">
				<div class="index-section3-text">创世蜜蜂APP是一款工程机械综合服务平台，囊括了八大业务——零配件商城更给力，配件种类全、品质优、价更低，电子签流程完整，更具法律效力；可以一对一租赁设备，线上签约电子合同，回款有保障；二手机交易价格自由，求购更精准；资讯快人一步，成功更进一步；机手招聘求职效率高、匹配准、更省力；大件物流不只是速度，还有放心；设备坏了不愁，在线一点即修；专门的金融方案蜜蜂白条，额度高、利息低、放款快、账期长，八大业务共同助力工程企业突破发展困局，蓬勃发展。
				</div>
			</div>
			<div class="text2">专业的工程机械零配件在线商城</div>
			<div class="index-section3-textBottomLan">
				<div class="section3-line"></div>
				<div class="section3-textBottom">创世蜜蜂</div>
				<div class="section3-line"></div>
			</div>
		</div>
		<div id="id4" style="width: 100%;background-color: #F4F4F4;position: relative;height: 931px;background-image: url(../../static/indexPic/img_tab1_bg1.png);">
			<img style="width: 100%;position: absolute;top: 0;left: 0;height: 931px;" src="../../static/indexPic/img_tab1_bg1.png"/>
			<div class="text3" >主营业务</div>
			<div class="zhuyingTitleLan">
				<img  class="zhuyingTitlePic" src="../../static/indexPic/img_pplogo.png"/>
			</div>
			<div class="zhuyingneirongArea">
				<div class="zhuyingneirongLan">
					<div class="zhuyingneirongBox" v-for="(item,index) in zhuyingList">
						<img  class="zhuyingneirongPic" :src="item.pic"/>
						<div class="zhuyingneirongName">{{item.name}}</div>
					</div>
				</div>
			</div>
			<div class="zhuyingneirongBottomTitle">数字科技——数字化解决方案</div>
			
			<!-- <div class="text1">主营业务</div>
			<div class="index-section4-boxArea">
				<div class="index-section4-boxLan">
					<div class="section4-box">
						<img class="section4-box-img" mode="widthFix"
							src="../../static/indexPic/icon_web04_01a@2x.png" />
						<div class="section4-box-text">电商一体化</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_02a@2x.png" />
						<div class="section4-box-text">挂账协议方案</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_03a@2x.png" />
						<div class="section4-box-text">电子发票</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_04a@2x.png" />
						<div class="section4-box-text">整机交易/租赁</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_05a@2x.png" />
						<div class="section4-box-text">云仓储/物流云</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_06a@2x.png" />
						<div class="section4-box-text">金融解决方案</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_07a@2x.png" />
						<div class="section4-box-text">营销矩阵</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_08a@2x.png" />
						<div class="section4-box-text">蜂豆体系</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_09a@2x.png" />
						<div class="section4-box-text">售后报修</div>
					</div>
					<div class="section4-box">
						<img class="section4-box-img" src="../../static/indexPic/icon_web04_10a@2x.png" />
						<div class="section4-box-text">招聘求职</div>
					</div>
				</div>
			</div> -->
		</div>
		<div id="id5" style="width: 100%;height: 100%;">
			<div class="section5-bgArea">
				<div class="text5">合作伙伴</div>
				<img class="section5-bg" src="../../static/pic/img_web01_bg1.jpg" />
				<img class="section5-partner" mode="widthFix" src="../../static/indexPic/img_web05_partner@2x.png" />
			</div>
		</div>
		<div id="id6" style="width: 100%;height: 100%;">
			<div class="section6-bgArea">
				<div class="text5">新闻资讯</div>
				<img class="section5-bg" src="../../static/pic/img_web01_bg2.jpg" />
				<div class="section5-newsArea">
					<div class="section5-newsLan" v-for="(item,index) in newsList" :key="index">
						<div class="section5-newsDate">
							<div class="section5-newsDate-day">{{item.day}}</div>
							<div class="section5-newsDate-month">/{{item.month}}</div>
						</div>
						<div class="section5-news">{{item.title}}</div>
					</div>
					<!-- <div class="section5-newsLan">
						<div class="section5-newsDate">
							<div class="section5-newsDate-day">20</div>
							<div class="section5-newsDate-month">/07</div>
						</div>
						<div class="section5-news">蜜蜂机械最新版本-二手车交易功能上线，期待各大经销
							商前来选购</div>
					</div>
					<div class="section5-newsLan">
						<div class="section5-newsDate">
							<div class="section5-newsDate-day">20</div>
							<div class="section5-newsDate-month">/07</div>
						</div>
						<div class="section5-news">蜜蜂机械最新版本-二手车交易功能上线，期待各大经销
							商前来选购</div>
					</div> -->
				</div>
				<div class="section5-detailBtn" @click="jumpNews">查看详情</div>
			</div>
		</div>

		<bottom-area></bottom-area>
	</div>
</template>

<script>
	import {
		newsList
	} from "../../api/news.js"
	import {
		bannerList
	} from "../../api/index.js"
	import bottomArea from "../components/bottomArea.vue"
	import anime from 'animejs/lib/anime.es.js'
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				bannerPic: [require('../../static/pic/img_web01_banner1.jpg'), ],
				windowHeight: String(document.documentElement.clientHeight),
				scrollFlag: false,
				newsList: [],
				bannerList: [],
				total: 0,
				form: {
					pageNum: 1,
					pageSize: 3
				},
				img_height: '',
				zhuyingList:[
					{
						pic:require("../../static/indexPic/icon_home_yw01.png"),
						name:"零配件商城"
					},{
						pic:require("../../static/indexPic/icon_home_yw02.png"),
						name:"设备租赁"
					},{
						pic:require("../../static/indexPic/icon_home_yw03.png"),
						name:"二手机交易"
					},{
						pic:require("../../static/indexPic/icon_home_yw04.png"),
						name:"资讯"
					},{
						pic:require("../../static/indexPic/icon_home_yw05.png"),
						name:"机手招聘求职"
					},{
						pic:require("../../static/indexPic/icon_home_yw06.png"),
						name:"大件物流"
					},{
						pic:require("../../static/indexPic/icon_home_yw07.png"),
						name:"售后维修"
					},{
						pic:require("../../static/indexPic/icon_home_yw08.png"),
						name:"金融"
					},
				]
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.testAnime()
			this.getBannerList()
			this.getNewsList()
		},
		methods: {
			img_load() {
				// console.log(this.$refs.img_ref[0].height, 'img_height')
				this.img_height = this.$refs.img_ref[0].height
				// console.log(this.$refs.img_ref[0].width, 'img_width')
			},
			jumpLink(item) {
				if (item.hyperLink !== null && item.hyperLink !== "") {
					window.open(item.hyperLink, '_blank')
				} else {

				}
			},
			getBannerList() {
				bannerList().then(res => {
					this.bannerList = res.data
					console.log(this.bannerList)
				}).catch(err => {
					console.log(err)
				})
			},
			getNewsList() {
				newsList(this.form).then(res => {
					this.newsList = res.data.rows
					this.total = res.data.total
				}).catch(err => {
					console.log(err)
				})
			},
			testAnime() {
				anime({
					targets: '#smallPic1',
					translateY: -20,
					direction: 'alternate',
					loop: true,
					easing: 'easeInOutSine'
				});
				anime({
					targets: '#smallPic2',
					translateY: -20,
					direction: 'alternate',
					loop: true,
					easing: 'easeInOutSine',
					delay: 200
				});
				anime({
					targets: '#smallPic3',
					translateY: -20,
					direction: 'alternate',
					loop: true,
					easing: 'easeInOutSine',
					delay: 400
				});
				anime({
					targets: '#smallPic4',
					translateY: -20,
					direction: 'alternate',
					loop: true,
					easing: 'easeInOutSine',
					delay: 600
				})
			},
			handleScroll() {
				let _this = this;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if (scrollTop) {
					_this.scrollFlag = true
				} else {
					_this.scrollFlag = false
				}
				// console.log(scrollTop);
				// if (scrollTop > 0 && scrollTop <= _this.windowHeight) {
				// 	document.documentElement.scrollTop = _this.windowHeight;
				// }
			},
			jumpNews() {
				this.$router.push({
					name: 'newsCenter'
				});
			},
			jumpToIndex() {
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#index {
		width: 100%;
		height: 100%;
	}

	.banner {
		width: 100%;
		/* height: 100%; */
	}

	.banner1 {
		width: 100%;
		height: 100%;
		position: relative;
		left: 0;
		z-index: 10;
	}

	.partner {
		position: absolute;
		width: 1165px;
		height: 560px;
		z-index: 50;
	}

	.text1 {
		width: 100%;
		text-align: center;
		font-size: 36px;
		font-family: PingFang SC;
		font-weight: 800;
		padding-top: 109px;
		color: #333333;
	}

	.index-section2-picLan {
		width: 100%;
		margin-top: 95px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.index-section2-picBox {
		width: 36.5%;
		height: auto;
		position: relative;
	}

	.section2-bigImg {
		/* position: absolute; */
		width: 100%;
		/* height: 460px; */
		mode: widthFix;
	}

	.section2-smallPic1 {
		position: absolute;
		top: -8%;
		left: 40%;
		width:17.7%;
		mode:widthFix;
		/* height: 133px; */
	}

	.section2-smallPic2 {
		position: absolute;
		/* width: 124px;
		height: 133px; */
		width:17.7%;
		mode:widthFix;
		/* top: 186px; */
		top: 38%;
		/* right: -30px; */
		right: -10%;
	}

	.section2-smallPic3 {
		position: absolute;
		/* width: 124px;
		height: 133px; */
		width:17.7%;
		mode:widthFix;
		/* bottom: -42px; */
		bottom: -10%;
		left: 40%;
	}

	.section2-smallPic4 {
		position: absolute;
		/* width: 124px;
		height: 133px; */
		width:17.7%;
		mode:widthFix;
		top: 36%;
		left: -10%;
	}

	.index-section2-textLan {
		margin-top: 40px;
		padding-bottom: 107px;
		width: 100%;
		display: flex;
		margin-right: 0;
		justify-content: center;

	}

	.index-section2-text {
		width: 1075px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #666666;
		line-height: 26px;
		text-align: left;
	}

	.index-section3-picLan {
		width: 100%;
		margin-top: 123px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.index-section3-picBox {
		width: 582px;
		height: 414px;
	}

	.section3-bigImg {
		width: 582px;
		height: 414px;
	}

	.index-section3-textLan {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 0px;
	}

	.index-section3-text {
		width: 1080px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #666666;
		line-height: 26px;
		text-align: left;
	}

	.text2 {
		width: 100%;
		text-align: center;
		margin-top: 30px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
	}

	.index-section3-textBottomLan {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		margin-top: 7px;
		margin-bottom: 35px;
	}

	.section3-line {
		width: 87px;
		height: 1px;
		background: #999999;
	}

	.section3-textBottom {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #666666;
		margin-left: 7px;
		margin-right: 7px;
	}

	.index-section4-boxArea {
		margin-top: 115px;
		padding-bottom: 115px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.index-section4-boxLan {
		width: 70%;
		height: widthFix;
	}

	.section4-box {
		float: left;
		width: 17%;
		/* height: 30%; */
		background: #FFFFFF;
		border-radius: 20px;
		/* padding: 38px 50px 88px 58px; */
		margin-left: 20px;
		margin-bottom: 25px;
		display: flex;
		flex-direction: column;
	}

	.section4-box-img {
		margin-top: 38px;
		margin-left: 23%;
		width: 53.5%;
		/* height: 120px; */
	}

	.section4-box-text {
		width: 100%;
		text-align: center;
		height: 30px;
		padding-top: 30px;
		font-size: 1.2em;
		/* font-size: 24; */
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin-bottom: 50px;
	}

	.section5-bgArea {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.section5-bg {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 10;
		left: 0;
		top: 0;
	}

	.section5-partner {
		width: 60%;
		position: absolute;
		left: 20%;
		z-index: 11;
		top: 270px;
	}

	.text5 {
		width: 100%;
		text-align: center;
		position: absolute;
		top: 108px;
		font-size: 36px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #FFFFFF;
		z-index: 20;
	}

	.section6-bgArea {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 30;
	}

	.section5-newsArea {
		position: absolute;
		top: 260px;
		left: 18.2%;
		width: 600px;
		display: flex;
		flex-direction: column;
		z-index: 50;
	}

	.section5-newsLan {
		width: 100%;
		height: 50px;
		margin-top: 60px;
	}

	.section5-newsDate {
		float: left;
		display: flex;
		flex-direction: row;
		height: 50px;
	}

	.section5-newsDate-day {
		font-size: 40px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 50px;
	}

	.section5-newsDate-month {
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 80px;
	}

	.section5-news {
		width: 430px;
		float: right;
		font-size: 18px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 28px;
		text-align: left;
	}

	.section5-detailBtn {
		position: absolute;
		width: 11%;
		height: 52px;
		background: #F8F8F8;
		border-radius: 5px;
		font-size: 18px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #467CFD;
		line-height: 52px;
		/* right: 350px; */
		left: 70%;
		/* bottom: 141px; */
		
		top: 80%;
		z-index: 40;
		cursor: pointer;
	}
	.text3{
		width: 100%;
		text-align: center;
		position: absolute;
		top: 109px;
		left: 0;
		font-size: 36px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #333333;
	}
	.zhuyingTitleLan{
		position: absolute;
		width: 100%;
		height: 42px;
		top: 225px;
		display: flex;
		justify-content: center;
	}
	.zhuyingTitlePic{
		width: 372px;
		height: 42px;
	}
	.zhuyingneirongArea{
		position: absolute;
		width: 100%;
		top: 320px;
		display: flex;
		justify-content: center;
		
	}
	.zhuyingneirongLan{
		width: 83.75rem;
		display: flex;
		flex-wrap: wrap;
	}
	.zhuyingneirongBox{
		width: 20.9375rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* margin-right: 16.25rem; */
		margin-top: 3.75rem;
		
	}
	.zhuyingneirongPic{
		width: 8.75rem;
		height: 8.75rem;
	}
	.zhuyingneirongName{
		width: 8.75rem;
		margin-top: 1.6875rem;
		font-size: 1.25rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #222222;
	}
	.zhuyingneirongBottomTitle{
		position: absolute;
		bottom: 36px;
		width: 100%;
		font-size: 26px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #999999;
	}
</style>
